import m from './module';
import FieldBlock from '../model/FieldBlock';
import {
  getProvisionalIdentifierForType,
  resetItemsDisplayOrder,
  sortItems
} from "../util";

const type = 'FieldBlock';

class FieldBlockService {
  constructor(
    $q,
    DataSyncService,
    LanguageService,
    LogService,
    FieldInstanceService,
    LogicGroupService,
    RoleVariableService,
    LocationService,
  ) {
    "ngInject";
    this.$q = $q;
    this.DataSyncService = DataSyncService;
    this.LanguageService = LanguageService;
    this.LogService = LogService;
    this.FieldInstanceService = FieldInstanceService;
    this.LogicGroupService = LogicGroupService;
    this.RoleVariableService = RoleVariableService;
    this.LocationService = LocationService;
  }

  create(data) {
    const dataCopy = data || {};
    dataCopy.id = dataCopy.id || getProvisionalIdentifierForType('fieldBlock');

    const recapDefinitionId = dataCopy.recapDefinitionId || dataCopy.events_recaps_id || null;

    const items = dataCopy.items || [];
    const itemsPromise = this.$q
      .all(
        items.map(
          item => this.$q.when(
            this.FieldInstanceService.create({
              ...item,
              recapDefinitionId,
            })
              .catch(err => {
                this.LogService.warn(`FieldBlockService.create() swallowing error creating field instance ${item.id} on field block ${dataCopy.id}:`, err);
                return null;
              })
          )
        )
      )
      .then(allItemsIncludingFailed => allItemsIncludingFailed.filter(item => !!item))
      .then(items => {
        dataCopy.items = items;
        dataCopy.items = sortItems(items);
      });

    const logicGroups = dataCopy.logic_groups || [];
    const logicGroupsPromise = this.$q
      .all(
        logicGroups.map(lg => this.$q.when(this.LogicGroupService.create(lg)))
      )
      .then(logicGroups => dataCopy.logic_groups = logicGroups);

    return this.$q.all([
      itemsPromise,
      logicGroupsPromise,
    ])
      .then(async () => {
        const fieldBlock = new FieldBlock(dataCopy);
        const fieldBlockWithoutItems = new FieldBlock(dataCopy);
        delete fieldBlockWithoutItems.items;
        for (const fieldInstance of fieldBlock.items) {
          // Make sure that the field instances have a reference to the field block
          // They need the reference for Field Block logic groups to work properly
          fieldInstance.fieldBlock = fieldBlockWithoutItems;
          await this.DataSyncService.setObjectById('FieldInstance', fieldInstance.id, fieldInstance);
        }
        return this.DataSyncService.setObjectById(type, dataCopy.id, fieldBlock);
      })
      .catch(err => {
        this.LogService.error(`FieldBlockService.create() error creating field block ${dataCopy.id} for recap definition ${recapDefinitionId}:`, err);
        return this.$q.reject(err);
      });
  }

  serialize(fieldBlock) {
    resetItemsDisplayOrder(fieldBlock.items);
    return {
      id: fieldBlock.id,
      items: fieldBlock.items.map(item => this.FieldInstanceService.serialize(item)),
      logic_groups: fieldBlock.logic_groups.map(group => this.LogicGroupService.serialize(group)),
      display_order: fieldBlock.display_order,
      location_variable_ids: fieldBlock.location_variables.map(lv => lv.id),
      role_variables: fieldBlock.role_variables.map(rv => this.RoleVariableService.serialize({...rv, events_custom_field_blocks_id: fieldBlock.id})),
      locations: fieldBlock.locations.map(loc => this.LocationService.serialize({...loc, events_custom_field_blocks_id: fieldBlock.id})),
    };
  }
}

export default FieldBlockService;

m.service('FieldBlockService', FieldBlockService);
